<script>
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { Bar } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'

export default {
  extends: Bar,
  props: {
    obj: {
      type: [Object, Array],
      default: () => ({
        labels: ['A', 'B', 'C', 'D', 'E'],
        data: {
          type: Array,
          default: () => [199540, 175382, 161231, 147721, 132886]
        }
      })
    },
    height: {
      type: [String, Number],
      default: 300
    },
    labelYLeft: {
      type: String,
      default: 'Y'
    },
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: {
      type: Number,
      default: 210000
    },
    color: {
      type: String,
      default: '#20a8d8'
    }
  },
  watch: {
    obj: {
      handler() {
        if(this.obj) {
          this.chart.labels = this.obj.labels ? this.obj.labels : ['Valor','Valor','Valor','Valor','Valor'];
          this.chart.datasets[0].data = this.obj.dataset[0].data;
          //this.chartProps.scales.yAxes[0].ticks.min = 0;
          this.refreshChart()
        }
      },
      deep: true
    }      
  },
  data: function () {
    return {
      chart: {
        labels: this.obj.labels,
        datasets: [
          {
            label: 'Dados',
            backgroundColor: hexToRgba(this.color, 10),
            borderColor: this.color,
            pointHoverBackgroundColor: '#fff',
            borderWidth: 2,
            data: this.obj.data
          }
        ]
      },
      chartProps: {
        plugins: [ChartDataLabels],
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
            }
          }
        },
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              drawOnChartArea: false
            }
          }],
          yAxes: [{
            id: 'y-axis-left',
            position: 'left',
            scaleLabel: {
              display: true,
              labelString: this.labelYLeft, // Left Y axis title
              fontColor: '#666',
              fontSize: 14,
              fontStyle: 'bold'
            },
            ticks: {
              id: 'y-axis-left',
              beginAtZero: true,
              maxTicksLimit: 5,
              stepSize: 5000,
              min: this.minValue,
              max: this.maxValue
            },
            gridLines: {
              display: true
            }
          }]
        },
        elements: {
          point: {
            radius: 0,
            hitRadius: 10,
            hoverRadius: 4,
            hoverBorderWidth: 3
          }
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: '#333',
            font: {
              weight: 'bold'
            },
            formatter: function(value) {
              return value.toLocaleString('pt-BR')
            }
          }
        }
      }
    }
  },
  methods: {
    refreshChart() {
      //console.log("refreshChart")
      //console.log(this.obj)
      this.renderChart(this.chart, this.chartProps)
    }
  },
  mounted () {
    this.refreshChart()
  }
}
</script>

